
<div class="container w-100 text-center mt-5">
  <b class="d-block mb-3">Pay your bills</b>
  <div class="d-flex justify-content-center">
    <div class="col-12 col-sm-10 col-md-8 col-lg-6">
      <app-paypal-order [registrationId]="registrationId"></app-paypal-order>
    </div>
  </div>
</div>
